import { render, staticRenderFns } from "./QiJuTianXieZhiNan.vue?vue&type=template&id=52f8eae2&scoped=true"
import script from "./QiJuTianXieZhiNan.vue?vue&type=script&lang=js"
export * from "./QiJuTianXieZhiNan.vue?vue&type=script&lang=js"
import style0 from "./QiJuTianXieZhiNan.vue?vue&type=style&index=0&id=52f8eae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f8eae2",
  null
  
)

export default component.exports